import {defineMessages} from 'react-intl';

const messages = defineMessages({
  minCharactersPassword: {
    id: 'minCharactersPassword',
    defaultMessage: 'Minimum {value} {value, plural, one {character} other {characters}}'
  },
  lowercaseLettersPassword: {
    id: 'lowercaseLettersPassword',
    defaultMessage: '{value} lowercase {value, plural, one {letter} other {letters}}'
  },
  uppercaseLettersPassword: {
    id: 'uppercaseLettersPassword',
    defaultMessage: '{value} uppercase {value, plural, one {letter} other {letters}}'
  },
  nummbersInPassword: {
    id: 'nummbersInPassword',
    defaultMessage: '{value} {value, plural, one {number} other {numbers}}'
  },
  nonAlphaInPassword: {
    id: 'nonAlphaInPassword',
    defaultMessage: '{value} non-alphanumeric {value, plural, one {character} other {characters}} (!@$&, etc.)'
  }
});

export default messages;
